import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { cardAnimations } from 'src/app/utilities/animations';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { GENERIC_ERROR, ISTATACARD, TRACK_APP, GENERIC_ERRORS, verbiageList, TRACK_APPLICATION_URL_DECRYPT, RETRIEVE_APPLICATION_URL_DECRYPT, VALIDATE_QDE_OTP_URL_DECRYPT, IS_CAMPAIGN, TRACK_GEN_NEW_URL_DECRYPT, REDIRECT_SWIFT_URL, RETRIEVE_GEN_OTP_DECRYPT, RETRIEVE_AUTH_NEW_URL_DECRYPT, TRACK_GEN_NEW_SHORTCODE_URL_DECRYPT } from 'src/app/config/app-settings.config';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';
import { QdeService } from 'src/app/services/qde.service';
import { EncrDecrService } from 'src/app/services/encr-decr-service.service';
import { map, filter, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { IwService } from 'src/app/services/iw.service';
import { ThemeService } from 'src/app/services/theme.service';

declare var _satellite: any;

@Component({
  selector: 'app-application-tracking',
  templateUrl: './application-tracking.component.html',
  styleUrls: ['./application-tracking.component.scss'],
  animations: [cardAnimations]
})
export class ApplicationTrackingComponent implements OnInit {
  verbiageList = verbiageList;
  resendOtp: boolean = false;
  fcnOtp = new FormControl('', [Validators.required]);
  trackApplicationServiceError: any;
  sendOtpServiceError: any;
  mobileNumber: any;
  otpValidationServiceError: any;
  retrieverServiceError: any;
  showScreen: boolean = true;
  retrieveRequest: any;
  TATACARD = ISTATACARD;
  otp_image: any;
  fromShortCode = false;
  displayShortCodeHtml: boolean = false;
  digitalTrackDisplayShortCodeHtml: boolean = false;
  track_app: any;
  generic_error: any;
  maxAttemptOtp: boolean = false;
  otpCounter = 0;
  otp: any;
  optValidateCount = 0;
  bancaPromoConfig: any;
  _cardtype: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  trackJourney: boolean = false;
  oldTrack: boolean = false;
//Digital tracking shortcode OTP validate throught response check varibale declared here
  trackCardDeliry: any;
  updateInstrintions: any;
  isOtpSectionDisable: boolean = false;
  showDigitalTrackDisplayShortCodeFlag : boolean = false;
  isDigitaltrackingOTPSectionDisable : boolean = false;
  maskedMobileNumber: any;

  mockAppStatusData =  {
    "courierName": "BLUE",
    "awsNumber": "34885685472",
    "courierLink": "https://www.bluedart.com/tracking",
    "cardDetailedStatus": [
        {
            "stepName": "Application Form Submitted",
            "stepState": "Completed"
        },
        {
            "stepName": "Application under quality checks/verification",
            "stepState": "Completed"
        },
        {
            "stepName": "Account Onboarding",
            "stepState": "Completed"
        },
        {
            "stepName": "E-Card delivery",
            "stepState": "Completed"
        },
        {
            "stepName": "Physical card delivery",
            "stepState": "Intrasit"
        }
    ]
}


  constructor(
    private sharedService: SharedServiceService,
    private router: Router,
    private loaderService: LoaderService,
    private qdeService: QdeService,
    private encryptDecService: EncrDecrService,
    private iw: IwService,
    private themeService: ThemeService
  ) {
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    this.bancaPromoConfig = this.iw.getBancaDefaultConfigurationDCR();
    this.track_app = TRACK_APP
    this.generic_error = GENERIC_ERRORS
    //document.getElementById('app-nav').style.display = "none";

    this.otp_image = this.TATACARD ? './tata-card-en/resources/img/eapply/SBI_Phase_2_OTP.png' : '/sbi-card-en/resources/img/eapply/SBI_Phase_2_OTP.png';
    this.navigateUser()
    // this.validateOtp();
    // this.validateRetrieveOtp()
  }
  navigateUser() {
    if (this.sharedService.paramsappNumber) {
      console.log('app track', this.sharedService.paramsappNumber);
      this.trackJourney = true;
      this.trackApplication()
    } else if ((this.sharedService.paramsmobileNo && this.sharedService.paramsfirstName) || this.sharedService.paramsshortCode) {
      console.log('retrieve', this.sharedService.paramsfirstName, this.sharedService.paramsmobileNo);
      this.trackJourney = false;
      if (this.sharedService.paramsmobileNo && this.sharedService.paramsfirstName) {
        this.sendRetrieveOtp(false);
      }
      else if (this.sharedService.paramsshortCode) {
        console.log('Entred in retrieve shortcode journey');
        this.sendShortCodeRetrieveOtp(false);    
       // this.digitalTrackDisplayShortCodeHtml = this.sharedService.digitrackingCardShortCodeFlag == true ? true : false;
        this.isOtpSectionDisable = true; 
      }
    }
  }

  resendNewOtp(flag) {
    if (this.trackJourney) {
      if(this.oldTrack){
        this.sendOtpForValidation(this.mobileNumber, true);
      }
      else {
        this.resendTrackOtp(flag);
      }
      
    }
    else {
      if (this.sharedService.paramsmobileNo && this.sharedService.paramsfirstName) {
        this.sendRetrieveOtp(flag);
      }
      else if (this.sharedService.digitrackingCardShortCodeFlag){
        this.sendRetrieveOtp(true);
      }
      else {
        this.sendShortCodeRetrieveOtp(flag);
      }
    }
  }

  validateNewOtp() {
    if (this.trackJourney) {
      if(this.oldTrack){
        this.validateOtp1();
      }
      else {
        this.validateOtp();
      }
      
    }
    else if (this.sharedService.digitrackingCardShortCodeFlag){
      this.digitalTrackValidShortcodeOTP();
    }
    else {
      this.validateRetrieveOtp();
    }
  }
  // verifyOtp() {
  //   if (this.fcnOtp) {
  //     this.verifyCount = this.verifyCount + 1
  //   }
  // }
  // resendCode() {
  //   this.resendOtp = true;
  //   setTimeout(() => {
  //     this.resendOtp = false;
  //   }, 1500)
  // }
  trackApplication() {
    console.log("Track service called from application-tracking-component");
    let request = {
      data: {
        applicationNumber: this.sharedService.paramsappNumber,
        leadRefNumber: this.sharedService.paramsappNumber,
        reasonCode: "101",
        orgId: "101",
        resendRequest: "false",
        regenerationFlag: "true"
      },
      action: "TrackOTPGen",
      type: "Swift App"
    }
    console.log("req for sendTrackOtp from application-tracking ==> ", request);
    this.sharedService.sendTrackOtp(request).subscribe((response: any) => {
      let res: any;
      console.log("res for sendTrackOtp from application-tracking ==> ", response);
      if (response) {
        response = TRACK_GEN_NEW_URL_DECRYPT ? this.encryptDecService.get(response) : response;
        console.log("track request", request);
        console.log("track response", res);
      }
      if (response && response.status && response.status == "Success" && response.statusCode && response.statusCode == "000" && response.data) {
        this.mobileNumber = response.data;
        this.maskedMobileNumber = response.maskedMobileNumber;
        console.log("masked mobile number:", this.maskedMobileNumber);
        this.sharedService.trackApplicationResponse = response;
        this.sendOtpServiceError = '';
        this.trackApplicationServiceError = '';
        this.retrieverServiceError = '';
        this.otpValidationServiceError = '';

        if (IS_CAMPAIGN) {
          window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
        } else {
          window["digitalData"].page = { pageName: 'sbi-card:eapply:track', pageType: 'Eapply' };
        }
        window["digitalData"].decisionType = this.sharedService.trackApplicationResponse.statusCode;
        // window["digitalData"].instantDecision = this.sharedService.trackApplicationResponse.statusDescription;
        // window["digitalData"].eapply = { number: this.sharedService.applicantApplicationNumber };
        window["digitalData"].eapply = { instantDecision: this.sharedService.trackApplicationResponse.statusDescription };
        window["digitalData"].application = { status: "complete", number: this.sharedService.applicantApplicationNumber };
        if (this.sharedService.cardName) {
          window["digitalData"].card = { cardName: this.sharedService.cardName };
        }
        if (window['_satellite']) {
          _satellite.track("track_application");
        }
      }
      else if (response && response.status && response.status == "Failure" && response.message) {
        this.trackApplication1();
        // this.trackApplicationServiceError = response.message;
        // this.sharedService.abortMessage = TRACK_APP.trackError;
        // this.router.navigate(['/track-application', 'track-error']);
      }
    }, error => {
      window["digitalData"].error = { message: GENERIC_ERROR };
      if (window['_satellite']) {
        _satellite.track('form_error');
      }
      console.log("Error has occured:", error);
      this.sharedService.abortMessage = TRACK_APP.trackError;
      this.router.navigate(['/track-application', 'track-error']);
      this.trackApplicationServiceError = GENERIC_ERROR;
    })
  }


  trackApplication1() {
    console.log("track service called from application-track");
    let request = {
      "applicationNumber": this.sharedService.paramsappNumber,
      "leadRefNo": this.sharedService.paramsappNumber
    }
    this.sharedService.trackApplication(request).subscribe((response: any) => {
      let res: any;
      if (response) {
        res = TRACK_APPLICATION_URL_DECRYPT ? { ...this.encryptDecService.get(response.body) } : { ...response.body };
        console.log("track request",request);
        console.log("trck response",res);
      }

      if (res && res.status && res.status.toLowerCase() == 'failure' && res.errorMessage) {
        this.trackApplicationServiceError = res.errorMessage
        this.sharedService.abortMessage = TRACK_APP.trackError;
        this.router.navigate(['/track-application', 'track-error']);
      } else if (res && res.eapplyApplicantDetails && res.eapplyApplicantDetails.mobileNumber) {
        let accessToken: any;
        let expiryTime: any;
        if (response.headers && response.headers.get("access_token")) {
          accessToken = response.headers.get("access_token");
        }
        if (response.headers && response.headers.get("expiry_time")) {
          expiryTime = response.headers.get("expiry_time");
        }
        if (accessToken) {
          sessionStorage.setItem("s24_access_token", accessToken);
        }
        if (expiryTime) {
          sessionStorage.setItem("s24_expiry_time", expiryTime);
        }
        this.sendOtpServiceError = '';
        this.trackApplicationServiceError='';
        this.retrieverServiceError='';
        this.otpValidationServiceError = '';
        this.mobileNumber = res.eapplyApplicantDetails.mobileNumber;
        this.sharedService.trackApplicationResponse = res;
        this.sharedService.applicantApplicationNumber = res.applicationNumber;
        this.sharedService.applicantName = res.eapplyApplicantDetails.firstName;
        this.sharedService.navigateToCompleteApp = res.enableDataCaptureFlag;
        this.sharedService.navigateToDocUpload = res.enableDocumentListFlag;
        this.sharedService.navigateToScheduleAppointment = res.enableAppointmentFlag;
        this.sharedService.navigateToAddon = res.enableAddOnListFlag;
        this.sharedService.navigateToCrossSell = res.enableCrossSellFlag;
        this.sharedService.navigateToResheduleAppointment = res.enableReSchdAppointmentFlag;
        this.sharedService.sbic_card_Type = res.cardType;
        let chaneelCode = res.channelCode ? res.channelCode : '';
        if(res.cardType == "null" || res.cardType == "") {
          this.sharedService.abortMessage != TRACK_APP.trackError;
          this.router.navigate(['/track-application', 'track-error']);
        }
        if (chaneelCode) {
          if (chaneelCode == "EALB") {
            this.sharedService.paramschannel = '901';
            sessionStorage.setItem('channelId','901');
          } else if (chaneelCode == "EABP") {
            this.sharedService.paramschannel = '701';
            sessionStorage.setItem('channelId','701');
          }
        }

        if (IS_CAMPAIGN) {
          window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
        } else {
          window["digitalData"].page = { pageName: 'sbi-card:eapply:track', pageType: 'Eapply' };
        }
        window["digitalData"].decisionType = this.sharedService.trackApplicationResponse.statusCode;
        // window["digitalData"].instantDecision = this.sharedService.trackApplicationResponse.statusDescription;
        // window["digitalData"].eapply = { number: this.sharedService.applicantApplicationNumber };
        window["digitalData"].eapply = { instantDecision: this.sharedService.trackApplicationResponse.statusDescription };
        window["digitalData"].application = { status: "complete", number: this.sharedService.applicantApplicationNumber };
        if (this.sharedService.cardName) {
          window["digitalData"].card = { cardName: this.sharedService.cardName };
        }
        if(window['_satellite']){
          _satellite.track("track_application");
        }
        
        if(this.trackJourney){
          this.oldTrack = true;
          this.sendOtpForValidation(this.mobileNumber, false);
        }
        else {
          this.router.navigate(['/apply', 'track-app'], { queryParamsHandling: "preserve" });
        }
        // this.router.navigate(['/apply', 'track-app'], { queryParamsHandling: "preserve" });
      }
    },
      error => {
        window["digitalData"].error = { message: GENERIC_ERROR };
        if(window['_satellite']){
          _satellite.track('form_error');
        }
        console.log("Error has occured:", error);
        this.sharedService.abortMessage = TRACK_APP.trackError;
        this.router.navigate(['/track-application', 'track-error']);
        this.trackApplicationServiceError = GENERIC_ERROR;
      })
  }
  resendTrackOtp(flag) {
    if (this.otpCounter >= 5) {
      return;
    }
    if (flag) {
      this.resendOtp = true;
      setTimeout(() => {
        this.resendOtp = false;
      }, 3000)
    }
    let request = {
      data: {
        applicationNumber: this.sharedService.paramsappNumber,
        leadRefNumber: this.sharedService.paramsappNumber,
        reasonCode: "101",
        orgId: "101",
        resendRequest: "true",
        regenerationFlag: "true"
      },
      action: "TrackOTPGen",
      type: "Swift App"
    }

    this.sharedService.sendTrackOtp(request).subscribe((response: any) => {
      if (response) {
        response = TRACK_GEN_NEW_URL_DECRYPT ? this.encryptDecService.get(response) : response;
        console.log("track request", request);
        console.log("track response", response);
      }
      if (response && response.status && response.status == "Success" && response.statusCode && response.statusCode == "000" && response.data) {
        this.sendOtpServiceError = '';
        this.trackApplicationServiceError = '';
        this.retrieverServiceError = '';
        this.otpValidationServiceError = '';
        this.displayShortCodeHtml = false;
        this.otpCounter = this.otpCounter + 1;
        this.otp = null;
        (this.otpCounter == 5) ? this.maxAttemptOtp = true : this.maxAttemptOtp = false;
      }
      else {
        this.sendOtpServiceError = GENERIC_ERROR
        window["digitalData"].error = { message: GENERIC_ERROR };
        if (window['_satellite']) {
          _satellite.track('form_error');
        }
      }
    }, error => {
      this.sendOtpServiceError = GENERIC_ERROR;
      window["digitalData"].error = { message: GENERIC_ERROR };
      if (window['_satellite']) {
        _satellite.track('form_error');
      }
    })
  }

  sendOtpForValidation(mobileNum, flag) {
    console.log("Send OTP for validation called from application-tracking-component")
    if (this.otpCounter >= 5) {
      return;
    }
    if (flag) {
      this.resendOtp = true;
      setTimeout(() => {
        this.resendOtp = false;
      }, 3000)
    }
    let reasonCode: any;
    if (this.sharedService.paramsappNumber) {
      // reasonCode = '132';
      reasonCode = '160';
    } else if (this.sharedService.paramsshortCode) {
      reasonCode = '121'
    } else {
      // reasonCode = '121';
      reasonCode = '161';
    }

    this.sharedService.sendOtp(mobileNum, '', flag, reasonCode).subscribe((res: any) => {
      if (res && res.OTPGenerationRsType && res.OTPGenerationRsType.status && res.OTPGenerationRsType.status.toLowerCase() == "success" && res.OTPGenerationRsType.statusCode === "000") {
        this.sendOtpServiceError = '';
        this.trackApplicationServiceError = '';
        this.retrieverServiceError = '';
        this.otpValidationServiceError = '';
        this.displayShortCodeHtml = false;
        this.otpCounter = this.otpCounter + 1;
        this.fcnOtp.setValue('');
        (this.otpCounter == 5) ? this.maxAttemptOtp = true : this.maxAttemptOtp = false;
      } else {
        this.sendOtpServiceError = GENERIC_ERROR
        window["digitalData"].error = { message: GENERIC_ERROR };
        if (window['_satellite']) {
          _satellite.track('form_error');
        }
      }
    }, error => {
      this.sendOtpServiceError = GENERIC_ERROR;
      window["digitalData"].error = { message: GENERIC_ERROR };
      if (window['_satellite']) {
        _satellite.track('form_error');
      }
    }
    )
  }

  sendRetrieveOtp(flag) {

    var request ;

    if(this.digitalTrackDisplayShortCodeHtml == true){
      
      request = {
      mobileNumber: this.sharedService.shortCodeMobileNumber,
      reasonCode: this.sharedService.shortCodeReasonCode,
      orgId: this.sharedService.shortCodeOrgId,
      resendRequest: flag,
      regenerationFlag: "true",
      creditCardNumber: this.sharedService.shortCodeCreditCardNumber,
               }
      }
      else{
         
     request = {
      mobileNumber: this.sharedService.paramsmobileNo,
      reasonCode: "101",
      orgId: "101",
      resendRequest: flag,
      regenerationFlag: "true"
    }
      }

    console.log(this.otpCounter)
    if (this.otpCounter >= 5) {
      return;
    }
    if (flag) {
      this.resendOtp = true;
      setTimeout(() => {
        this.resendOtp = false;
      }, 3000)
    }
    this.sharedService.sendRetrieveOtp(request).subscribe((response: any) => {
      if (response) {
        response = RETRIEVE_GEN_OTP_DECRYPT ? this.encryptDecService.get(response) : response;
        console.log("Send retrieve otp called from application tracking ", response);
      }
      if (response && response.status.toLowerCase() === "success" && response.statusCode === "000") {
        this.isOtpSectionDisable = false;
        this.showDigitalTrackDisplayShortCodeFlag = true;
        this.mobileNumber = this.sharedService.paramsmobileNo;
        this.isDigitaltrackingOTPSectionDisable = false;
        console.log("retrieve otp send success from application tracking");
        if (flag === true) {
          this.sendOtpServiceError = '';
          this.trackApplicationServiceError = '';
          this.retrieverServiceError = '';
          this.otpValidationServiceError = '';
          this.displayShortCodeHtml = false;
          this.otpCounter = this.otpCounter + 1;
          this.otp = null;
          (this.otpCounter == 5) ? this.maxAttemptOtp = true : this.maxAttemptOtp = false;
        }

      }
      else if (response && response.status && response.status == "Failure" && response.message) {
        this.trackApplicationServiceError = response.message;
        this.sharedService.abortMessage = TRACK_APP.trackError;
        this.router.navigate(['/track-application', 'track-error']);
      }
      else {
        this.trackApplicationServiceError = response.message;
        this.sharedService.abortMessage = TRACK_APP.trackError;
        this.router.navigate(['/track-application', 'track-error']);
      }


    }, error => {
      window["digitalData"].error = { message: GENERIC_ERROR };
      if (window['_satellite']) {
        _satellite.track('form_error');
      }
      console.log("Error has occured:", error);
      this.sharedService.abortMessage = TRACK_APP.trackError;
      this.router.navigate(['/track-application', 'track-error']);
      this.trackApplicationServiceError = GENERIC_ERROR;
    })
  }

  sendShortCodeRetrieveOtp(flag) {
    console.log("sendShortCodeRetrieveOtp function start");
    // let request = {
    //   shortCode: this.sharedService.paramsshortCode,
    //   reasonCode: "101",
    //   orgId: "101",
    //   resendRequest: flag,
    //   regenerationFlag: "true"
    // }
    let request = {
      data: {
        shortCode: this.sharedService.paramsshortCode,
        reasonCode: "101",
        orgId: "101",
        resendRequest: flag,
        regenerationFlag: "true"
      },
      action: "C2B",
      type: "Swift App"
    }
    console.log(this.otpCounter)
    if (this.otpCounter >= 5) {
      return;
    }
    if (flag) {
      this.resendOtp = true;
      setTimeout(() => {
        this.resendOtp = false;
      }, 3000)
    }
    this.sharedService.retrieveAppAuth(request).subscribe((response: any) => {
      console.log('function sendShortCodeRetrieveOtp response:: ', response);
      if (response) {
        response = RETRIEVE_GEN_OTP_DECRYPT ? this.encryptDecService.get(response) : response;
        console.log("Send retrieve short code otp called from application tracking ", response);
        this.digitalTrackDisplayShortCodeHtml = response.shortCodeValidatedForTrackApp;
        this.sharedService.awbnumber = response.AWBNumber;
        this.sharedService.courierPartnerId = response.CourierPartnerId;
        this.sharedService.courierPartnerName = response.CourierPartnerName;
        this.sharedService.shortCodeCreditCardNumber = response.creditCardNumber;
        this.sharedService.shortCodeMobileNumber = response.mobileNumber;
        this.sharedService.shortCodeOrgId = response.orgId;
        this.sharedService.shortCodeReasonCode = response.reasonCode;
        this.sharedService.digitrackingCardShortCodeFlag = this.digitalTrackDisplayShortCodeHtml;
        if(response.errorCode === "300"){
          console.log('shortcode service failure case 300');
          this.sharedService.DigitalTrackShortCodeExpiredError = TRACK_APP.DIGITRACK_SHORTCODE_FAILURE_MSG;
          this.sharedService.shotCodeServiceFailedFlag = true;
          this.router.navigate(['/track-application', 'track-error']);
        }
        else if(response.errorCode === "999"){
          console.log('shortcode expired case 999');
          this.sharedService.DigitalTrackShortCodeExpiredError = TRACK_APP.DIGITRACK_SHORTCODE_EXPIRED_MSG;
          this.sharedService.shotCodeServiceFailedFlag = true;
          this.router.navigate(['/track-application', 'track-error']);
        }
        if(this.digitalTrackDisplayShortCodeHtml == true){
          console.log("isDigitaltrackingOTPSectionDisable ifpart", this.isDigitaltrackingOTPSectionDisable);
          this.isDigitaltrackingOTPSectionDisable = true;
        }
        else{
          console.log("isDigitaltrackingOTPSectionDisable elsepart", this.isDigitaltrackingOTPSectionDisable);
          this.isDigitaltrackingOTPSectionDisable = false;
        }

      }
      if (response && response.status.toLowerCase() === "success" && response.statusCode === "000") {
        this.mobileNumber = response.data.mobile;
        this.sharedService.paramsmobileNo = response.data.mobile;
        this.sharedService.paramsfirstName = response.data.firstName;
        console.log("retrieve short code otp send success from application tracking");
        if (flag === true) {
          this.sendOtpServiceError = '';
          this.trackApplicationServiceError = '';
          this.retrieverServiceError = '';
          this.otpValidationServiceError = '';
          this.displayShortCodeHtml = false;
          this.otpCounter = this.otpCounter + 1;
          this.otp = null;
          (this.otpCounter == 5) ? this.maxAttemptOtp = true : this.maxAttemptOtp = false;
        }

      }
      // shortcode service failure case 300
      else if(response && response.errorCode === "300"){
        // this.trackApplicationServiceError = response.message;
        console.log('shortcode service failure case 300 else if');
        this.sharedService.DigitalTrackShortCodeExpiredError = TRACK_APP.DIGITRACK_SHORTCODE_FAILURE_MSG;
        this.sharedService.shotCodeServiceFailedFlag = true;
        this.router.navigate(['/track-application', 'track-error']);
      }
      // shortcode expired case 999
      else if(response && response.errorCode === "999"){
        console.log('shortcode expired case 999 else if');
        // this.trackApplicationServiceError = response.message;
        this.sharedService.DigitalTrackShortCodeExpiredError = TRACK_APP.DIGITRACK_SHORTCODE_EXPIRED_MSG;
        this.sharedService.shotCodeServiceFailedFlag = true;
        this.router.navigate(['/track-application', 'track-error']);
      }
      else if (response && response.status && response.status == "Failure" && response.message) {
        this.trackApplicationServiceError = response.message;
        this.sharedService.abortMessage = TRACK_APP.trackError;
        this.router.navigate(['/track-application', 'track-error']);
      }
      else {
        this.trackApplicationServiceError = response.message;
        this.sharedService.abortMessage = TRACK_APP.trackError;
        this.router.navigate(['/track-application', 'track-error']);
      }


    }, error => {
      window["digitalData"].error = { message: GENERIC_ERROR };
      if (window['_satellite']) {
        _satellite.track('form_error');
      }
      console.log("Error has occured:", error);
      this.sharedService.abortMessage = TRACK_APP.trackError;
      this.router.navigate(['/track-application', 'track-error']);
      this.trackApplicationServiceError = GENERIC_ERROR;
    })

  }

  // retrieveApplication() {
  //   console.log("retrieve service called from apllication-track");
  //   if (this.sharedService.paramsshortCode) {
  //     this.fromShortCode = true
  //     this.displayShortCodeHtml = true;
  //     this.retrieveRequest = {
  //       "WSCallShortCode": this.sharedService.paramsshortCode
  //     }
  //   } else {
  //     this.retrieveRequest = {
  //       "WSCallUserFirstName": this.sharedService.paramsfirstName,
  //       "WSCallUserMobileNumber": this.sharedService.paramsmobileNo
  //     }
  //   }

  //   this.sharedService.retriveApplication(this.retrieveRequest).subscribe((res: any) => {
  //     if (res) {
  //       res = RETRIEVE_APPLICATION_URL_DECRYPT ? this.encryptDecService.get(res) : res;
  //       console.log("retrieve request", this.retrieveRequest);
  //       console.log("retrieve response", res);
  //     }
  //     if (res && res.RetrieveLeadErrorRsType && res.RetrieveLeadErrorRsType.status.toLowerCase() == 'failure') {
  //       this.retrieverServiceError = res.RetrieveLeadErrorRsType.errorMessage
  //       this.sharedService.abortMessage = TRACK_APP.trackError;
  //       window["digitalData"].error = { message: this.retrieverServiceError };
  //       if (window['_satellite']) {
  //         _satellite.track('form_error');
  //       }
  //       this.router.navigate(['/track-application', 'track-error']);
  //     } else if (res) {
  //       this.sendOtpServiceError = '';
  //       this.trackApplicationServiceError = '';
  //       this.retrieverServiceError = '';
  //       this.otpValidationServiceError = '';
  //       if (res.RetrieveLeadRsType.WSCallLeadRefNumber) {
  //         this.sharedService.paramsappNumber = res.RetrieveLeadRsType.WSCallLeadRefNumber;
  //         this.trackApplication();
  //       } else {
  //         this.retrieverServiceError = ''
  //         this.sharedService.retrievedApplicationResponse = res;
  //         let chaneelCode = res.RetrieveLeadRsType.WSCallChannelCode ? res.RetrieveLeadRsType.WSCallChannelCode : '';
  //         this._cardtype = res.RetrieveLeadRsType && res.RetrieveLeadRsType.WSCallCardType ? res.RetrieveLeadRsType.WSCallCardType : '';
  //         if (chaneelCode) {
  //           if (chaneelCode == "EALB") {
  //             this.sharedService.paramschannel = '901';
  //             sessionStorage.setItem('channelId', '901');
  //           } else if (chaneelCode == "EABP") {
  //             this.sharedService.paramschannel = '701';
  //             sessionStorage.setItem('channelId', '701');
  //           }
  //         }

  //         if (this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallChannelCode) {
  //           let masterReq = {
  //             cardType: this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallCardType,
  //             cardChannelCode: this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallChannelCode,
  //             cityList: 'N',
  //             companyList: 'N',
  //             bancaCityList: 'N',
  //             userCity: this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCity || null
  //           }
  //           this.loaderService.show()
  //           this.qdeService.fetchMatserData(masterReq).subscribe((response: any) => {
  //             if (response.eapplyMasterDataRsType && response.eapplyMasterDataRsType.statusCode === "000") {
  //               this.sharedService.InitialMasterResponse = response;
  //               this.sharedService.sourceCode = 'DEFEAP';
  //               // if ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') || (this.sharedService.paramschannel && this.sharedService.paramschannel == '901')) {
  //               //   this.sharedService.promoCode = response 
  //               //         && response.eapplyMasterDataRsType 
  //               //         && response.eapplyMasterDataRsType.wcpParameters 
  //               //         && response.eapplyMasterDataRsType.wcpParameters.promoCode 
  //               //           ? response.eapplyMasterDataRsType.wcpParameters.promoCode: '' ;
  //               // }
  //               if (res.eapplyMasterDataRsType && res.eapplyMasterDataRsType.wcpParameters) {
  //                 this.sharedService.sourceCode = res.eapplyMasterDataRsType.wcpParameters.sourceCode;
  //                 this.sharedService.promoGroup = res.eapplyMasterDataRsType.wcpParameters.promoGroup;
  //               }
  //               if ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') || (this.sharedService.paramschannel && this.sharedService.paramschannel == '901')) {

  //                 if (this.sharedService.InitialMasterResponse && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode) {
  //                   this.sharedService.promoCode = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode;
  //                 } else {
  //                   if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
  //                     if (this._cardtype == 'USV2') {
  //                       this.sharedService.promoCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-unnati-card-promo-code').key_value;
  //                     } else {
  //                       this.sharedService.promoCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-promo-code').key_value;
  //                     }
  //                   }
  //                 }

  //                 if (this.sharedService.InitialMasterResponse && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoGroup) {
  //                   this.sharedService.promoGroup = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoGroup;
  //                 } else {
  //                   if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
  //                     if (this._cardtype == 'USV2') {
  //                       this.sharedService.promoGroup = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-unnati-card-promo-group').key_value;
  //                     } else {
  //                       this.sharedService.promoGroup = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-promo-group').key_value;
  //                     }
  //                   }
  //                 }

  //                 if (this.sharedService.InitialMasterResponse && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.sourceCode) {
  //                   this.sharedService.sourceCode = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.sourceCode;
  //                 } else {
  //                   if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
  //                     this.sharedService.sourceCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-source-code').key_value;
  //                   } else {
  //                     this.sharedService.sourceCode = 'DEFEAP';
  //                   }
  //                 }
  //               }
  //               this.loaderService.hide()
  //             } else {
  //               this.loaderService.hide()
  //               window["digitalData"].error = { message: GENERIC_ERROR };
  //               if (window['_satellite']) {
  //                 _satellite.track('form_error');
  //               }
  //               this.retrieverServiceError = GENERIC_ERROR;
  //             }
  //           }, err => {
  //             this.retrieverServiceError = GENERIC_ERROR;
  //             window["digitalData"].error = { message: GENERIC_ERROR };
  //             if (window['_satellite']) {
  //               _satellite.track('form_error');
  //             }
  //             this.loaderService.hide()
  //           });
  //           // if ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') || (this.sharedService.paramschannel && this.sharedService.paramschannel == '901')) {
  //           //   this.sharedService.promoCode = this.sharedService.InitialMasterResponse 
  //           //         && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType 
  //           //         && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters 
  //           //         && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode 
  //           //           ? this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode: ''
  //           // }
  //         }
  //         this.sharedService.applicantName = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserFirstName;
  //         this.mobileNumber = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMobileNumber;

  //         let sequenceId = res.RetrieveLeadRsType.WSCallSequenceId ? res.RetrieveLeadRsType.WSCallSequenceId : '';
  //         this.sharedService.amoSequeceNumber = sequenceId;
  //         if (IS_CAMPAIGN) {
  //           window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
  //         } else {
  //           window["digitalData"].page = { pageName: 'sbi-card:eapply:retrieve', pageType: 'Eapply' };
  //         }
  //         if (!this.fromShortCode) {
  //           this.sendOtpForValidation(this.mobileNumber, false);
  //           if (IS_CAMPAIGN) {
  //             window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
  //           } else {
  //             window["digitalData"].page = { pageName: 'sbi-card:eapply:c2b', pageType: 'Eapply' };
  //           }
  //         }
  //       }
  //     }
  //   }, error => {
  //     this.sharedService.abortMessage = TRACK_APP.trackError;
  //     window["digitalData"].error = { message: GENERIC_ERROR };
  //     if (window['_satellite']) {
  //       _satellite.track('form_error');
  //     }
  //     this.router.navigate(['/track-application', 'track-error']);
  //     this.retrieverServiceError = GENERIC_ERROR;
  //   })
  // }

  validateOtp1() {
    if (this.otp.length === 6) {
      const requestBody = {
        cardNumber: '000' + this.mobileNumber + '999999',
        otp: this.otp || null,
        reasonCode: '160',
        mobileNumber: '' + this.mobileNumber,
        dsignString: this.sharedService.uuidString
      }
      let reasonCode: any;
      if (this.sharedService.paramsappNumber) {
        reasonCode = '160';
      } else if (this.sharedService.paramsshortCode) {
        reasonCode = '121'
      } else {
        reasonCode = '161';
      }

      this.sharedService.validateOtp(requestBody, reasonCode).subscribe((res: any) => {
        if (res) {
          res = VALIDATE_QDE_OTP_URL_DECRYPT ? this.encryptDecService.get(res) : res;
        }
        if (res && res.OtpValidationRsType && res.OtpValidationRsType.status && res.OtpValidationRsType.status.toLowerCase() == "success" && res.OtpValidationRsType.statusCode === "000" && res.OtpValidationRsType.dsignString === this.sharedService.uuidString) {
          if (window['_satellite']) {
            _satellite.track("mobile_number_verify");
          }
          this.otpValidationServiceError = '';
          this.sendOtpServiceError = '';
          this.optValidateCount += 1;
          if (res.OtpValidationRsType.signedValue) {
            this.qdeService.signedValueResponse = res.OtpValidationRsType.signedValue;
          }

          if (this.sharedService.paramsappNumber && res.OtpValidationRsType.mobileNumber == this.mobileNumber) {
            this.router.navigate(['/apply', 'track-app'], { queryParamsHandling: "preserve" });
          } else if (((this.sharedService.paramsmobileNo && this.sharedService.paramsfirstName) || this.sharedService.paramsshortCode) && res.OtpValidationRsType.mobileNumber == this.mobileNumber) {
            this.router.navigate(['/', 'apply'], { queryParamsHandling: "preserve", replaceUrl: true });
          } else {
            this.sharedService.abortMessage = TRACK_APP.trackError;
            this.router.navigate(['/track-application', 'track-error']);
          }
        } else {
          this.optValidateCount += 1;
          this.otpValidationServiceError = verbiageList.invalidOtp;
          this.fcnOtp.setValue('');
          // this.retrieverServiceError = GENERIC_ERROR;
          window["digitalData"].error = { message: GENERIC_ERROR };
        }
      }), error => {
        this.otpValidationServiceError = GENERIC_ERROR;
        this.retrieverServiceError = GENERIC_ERROR;
        window["digitalData"].error = { message: GENERIC_ERROR };
      }
    }
  }

  validateOtp() {
    if (this.otp.length === 6) {
      const requestBody = {
        data: {
          applicationNumber: this.sharedService.paramsappNumber,
          mobileNumber: '' + this.mobileNumber,
          reasonCode: "101",
          otp: this.otp || null,
          dsignString: this.sharedService.uuidString
        },
        action: "TrackOTPAuth",
        type: "Swift App"
      }
      // && res.data.dsignString === this.sharedService.uuidString        =======> to be include in the if statement with status check....

      this.sharedService.trackAppAuth(requestBody).subscribe((res: any) => {
        if (res) {
          console.log(res);
          res = TRACK_GEN_NEW_URL_DECRYPT ? this.encryptDecService.get(res) : res;
          console.log("Track auth res => ", res);
          console.log("Track auth req => ", requestBody);
        } else {
          
        }
        if (res && res.status && res.status.toLowerCase() == "success") {
          this.sharedService.fromSwiftJourney = true;
          sessionStorage.setItem('fromSwiftJourney', 'true');
          if (window['_satellite']) {
            _satellite.track("mobile_number_verify");
          }

          if (res.statusCode === "000") {
            console.log("Normal existing journey from Track app", res.data.channelCode);
            console.log("Normal existing journey from Track app CORP", res.data.channelCode == "CORP", res.data.channelCode == 'CORP');
            console.log("CORP condition---", res.data["channelCode"] == "CORP", res.data["channelCode"] == 'CORP');
            // if(res.data.channelCode == "CORP"){
            //     console.log("track to corporate");
            //     // this.router.navigate(['/track-application', 'corporate-card']);
            //     // setTimeout(() => this.router.navigate(["/corporate-card"]), 0);
            //     this.router.navigateByUrl('track-application/corporate-card');
            //     // this.router.navigate(['/track-application','corporate-card']).then(res => {console.log(res)}).catch(error => {console.log(error)});
            // }
            this.otpValidationServiceError = '';
            this.sendOtpServiceError = '';
            this.optValidateCount += 1;
            this.sharedService.trackApplicationResponse = res;
            this.sharedService.applicantName = res.data.applicantDetails.firstName;
            this.sharedService.applicantApplicationNumber = res.data.applicationNumber;
            this.sharedService.navigateToCompleteApp = res.data.enableDataCaptureFlag;
            this.sharedService.navigateToDocUpload = res.data.enableDocumentListFlag;
            this.sharedService.navigateToScheduleAppointment = res.data.enableAppointmentFlag;
            this.sharedService.navigateToAddon = res.data.enableAddOnListFlag;
            this.sharedService.navigateToCrossSell = res.data.enableCrossSellFlag;
            this.sharedService.navigateToResheduleAppointment = res.data.enableReSchdAppointmentFlag;
            // if (res.signedValue) {
            //   this.qdeService.signedValueResponse = res.signedValue;
            // }
            // if(res.data.statusCode == 'FFMP' || res.data.statusCode == 'DCQV') {
            //   this.sharedService.navigateToCompleteApp = true;
            // }
            // else {
            //   this.sharedService.navigateToCompleteApp = false;
            // }

            if(this.sharedService.paramsappNumber && res.data.applicantDetails.mobileNumber == this.mobileNumber && res.data.channelCode == "CORP" || res.data.channelCode == "corp") {
              this.router.navigate(["/track-application/corporate-card"]);
            } else if (this.sharedService.paramsappNumber && res.data.applicantDetails.mobileNumber == this.mobileNumber) {
              this.router.navigate(['/apply', 'track-app'], { queryParamsHandling: "preserve" });
            } else if (((this.sharedService.paramsmobileNo && this.sharedService.paramsfirstName) || this.sharedService.paramsshortCode) && res.data.applicantDetails.mobileNumber == this.mobileNumber) {
              this.router.navigate(['/', 'apply'], { queryParamsHandling: "preserve", replaceUrl: true });
            } else {
              this.sharedService.abortMessage = TRACK_APP.trackError;
              this.router.navigate(['/track-application', 'track-error']);
            }
          }
          else if (res.statusCode === "001" && res.data.dsignString === this.sharedService.uuidString) {
            console.log("redirecting to swift app");
            let link = `${REDIRECT_SWIFT_URL}?track=${res.data.hsToken}`;
            console.log("Swift App Link", link);
            // window.open(link);
            window.location.href = link;
          }
        }
        else {
          console.log("this is else block from validateOtp application-tracking")
          this.optValidateCount += 1;
          this.otpValidationServiceError = verbiageList.invalidOtp;
          this.otp = null;
          // this.retrieverServiceError = GENERIC_ERROR;
          window["digitalData"].error = { message: GENERIC_ERROR };
          // this.trackApplication1();

        }
      }), error => {
        this.otpValidationServiceError = GENERIC_ERROR;
        this.retrieverServiceError = GENERIC_ERROR;
        window["digitalData"].error = { message: GENERIC_ERROR };
      }
    }
  }

  validateRetrieveOtp() {
    if (this.otp.length === 6) {
      let request = {
        data: {
          firstName: this.sharedService.paramsfirstName,
          mobileNumber: this.sharedService.paramsmobileNo,
          reasonCode: "101",
          otp: this.otp || null,
          dsignString: this.sharedService.uuidString
        },
        action: "RetrieveOTPAuth",
        type: "Swift App"
      }
      this.sharedService.retrieveAppAuth(request).subscribe((response: any) => {
        console.log(' Function validateRetrieveOtp subscribe');
        if (response) {
          response = RETRIEVE_AUTH_NEW_URL_DECRYPT ? this.encryptDecService.get(response) : response;
          console.log("Retrieve auth res => ", response);
          console.log("Retrieve req => ", request);
        }
        if (response && response.status && response.status.toLowerCase() == "success") {
          if(response.signedValue){
            this.qdeService.signedValueResponse = response.signedValue;
            console.log("signedValue", this.qdeService.signedValueResponse);
          }
          if (response.statusCode === "004") {
            console.log("Normal retrieve journey to be executed from application tracking component");
            this.sendOtpServiceError = '';
            this.trackApplicationServiceError = '';
            this.retrieverServiceError = '';
            this.otpValidationServiceError = '';
            if (response.RetrieveLeadRsType.WSCallLeadRefNumber) {
              this.sharedService.paramsappNumber = response.RetrieveLeadRsType.WSCallLeadRefNumber;
              this.trackApplication1();
            } else if (((this.sharedService.paramsmobileNo && this.sharedService.paramsfirstName) || this.sharedService.paramsshortCode) && response.RetrieveLeadRsType.WSCallUserMobileNumber == this.mobileNumber) {
              this.sharedService.retrievedApplicationResponse = response;
              this.router.navigate(['/', 'apply'], { queryParamsHandling: "preserve", replaceUrl: true });
            }
            else {
              this.retrieverServiceError = ''
              this.sharedService.retrievedApplicationResponse = response;
              let chaneelCode = response.RetrieveLeadRsType.WSCallChannelCode ? response.RetrieveLeadRsType.WSCallChannelCode : '';
              this._cardtype = response.RetrieveLeadRsType && response.RetrieveLeadRsType.WSCallCardType ? response.RetrieveLeadRsType.WSCallCardType : '';
              if (chaneelCode) {
                if (chaneelCode == "EALB") {
                  this.sharedService.paramschannel = '901';
                  sessionStorage.setItem('channelId', '901');
                } else if (chaneelCode == "EABP") {
                  this.sharedService.paramschannel = '701';
                  sessionStorage.setItem('channelId', '701');
                }
              }

              if (this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallChannelCode) {
                let masterReq = {
                  cardType: this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallCardType,
                  cardChannelCode: this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallChannelCode,
                  cityList: 'N',
                  companyList: 'N',
                  bancaCityList: 'N',
                  userCity: this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCity || null
                }
                this.loaderService.show()
                this.qdeService.fetchMatserData(masterReq).subscribe((res: any) => {
                  if (res.eapplyMasterDataRsType && res.eapplyMasterDataRsType.statusCode === "000") {
                    this.sharedService.InitialMasterResponse = res;
                    this.sharedService.sourceCode = 'DEFEAP';
                    // if ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') || (this.sharedService.paramschannel && this.sharedService.paramschannel == '901')) {
                    //   this.sharedService.promoCode = response 
                    //         && response.eapplyMasterDataRsType 
                    //         && response.eapplyMasterDataRsType.wcpParameters 
                    //         && response.eapplyMasterDataRsType.wcpParameters.promoCode 
                    //           ? response.eapplyMasterDataRsType.wcpParameters.promoCode: '' ;
                    // }
                    if (res.eapplyMasterDataRsType && res.eapplyMasterDataRsType.wcpParameters) {
                      this.sharedService.sourceCode = res.eapplyMasterDataRsType.wcpParameters.sourceCode;
                      this.sharedService.promoGroup = res.eapplyMasterDataRsType.wcpParameters.promoGroup;
                    }
                    if ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') || (this.sharedService.paramschannel && this.sharedService.paramschannel == '901')) {

                      if (this.sharedService.InitialMasterResponse && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode) {
                        this.sharedService.promoCode = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode;
                      } else {
                        if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
                          if (this._cardtype == 'USV2') {
                            this.sharedService.promoCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-unnati-card-promo-code').key_value;
                          } else {
                            this.sharedService.promoCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-promo-code').key_value;
                          }
                        }
                      }

                      if (this.sharedService.InitialMasterResponse && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoGroup) {
                        this.sharedService.promoGroup = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoGroup;
                      } else {
                        if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
                          if (this._cardtype == 'USV2') {
                            this.sharedService.promoGroup = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-unnati-card-promo-group').key_value;
                          } else {
                            this.sharedService.promoGroup = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-promo-group').key_value;
                          }
                        }
                      }

                      if (this.sharedService.InitialMasterResponse && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.sourceCode) {
                        this.sharedService.sourceCode = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.sourceCode;
                      } else {
                        if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
                          this.sharedService.sourceCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-source-code').key_value;
                        } else {
                          this.sharedService.sourceCode = 'DEFEAP';
                        }
                      }
                    }
                    this.loaderService.hide()
                  } else {
                    this.loaderService.hide()
                    window["digitalData"].error = { message: GENERIC_ERROR };
                    if (window['_satellite']) {
                      _satellite.track('form_error');
                    }
                    this.retrieverServiceError = GENERIC_ERROR;
                  }
                }, err => {
                  this.retrieverServiceError = GENERIC_ERROR;
                  window["digitalData"].error = { message: GENERIC_ERROR };
                  if (window['_satellite']) {
                    _satellite.track('form_error');
                  }
                  this.loaderService.hide()
                });
                // if ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') || (this.sharedService.paramschannel && this.sharedService.paramschannel == '901')) {
                //   this.sharedService.promoCode = this.sharedService.InitialMasterResponse 
                //         && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType 
                //         && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters 
                //         && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode 
                //           ? this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode: ''
                // }
              }
              this.sharedService.applicantName = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserFirstName;
              this.mobileNumber = this.sharedService.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMobileNumber;

              let sequenceId = response.RetrieveLeadRsType.WSCallSequenceId ? response.RetrieveLeadRsType.WSCallSequenceId : '';
              this.sharedService.amoSequeceNumber = sequenceId;
              if (IS_CAMPAIGN) {
                window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
              } else {
                window["digitalData"].page = { pageName: 'sbi-card:eapply:retrieve', pageType: 'Eapply' };
              }
              if (!this.fromShortCode) {
                this.sendOtpForValidation(this.mobileNumber, false);
                if (IS_CAMPAIGN) {
                  window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
                } else {
                  window["digitalData"].page = { pageName: 'sbi-card:eapply:c2b', pageType: 'Eapply' };
                }
              }
            }
          }
          else if(response.statusCode === "006"){
            this.sharedService.abortMessage = TRACK_APP.trackError;
            window["digitalData"].error = { message: GENERIC_ERROR };
            if (window['_satellite']) {
              _satellite.track('form_error');
            }
            this.router.navigate(['/track-application', 'track-error']);
            this.retrieverServiceError = GENERIC_ERROR;
          }
          else if (response.statusCode === "001" || response.statusCode === "002") {
            console.log("This is 002 for retrieve Otp validation in application tracking component");
            this.sharedService.fromSwiftJourney = true;
            this.fromShortCode = true;
            this.sharedService.trackApplicationResponse = response;
            this.sendOtpServiceError = '';
            this.trackApplicationServiceError = '';
            this.retrieverServiceError = '';
            this.otpValidationServiceError = '';
            
            if (response.statusCode === "002" && response.data.dsignString === this.sharedService.uuidString) {
              console.log("redirecting to swift app retrieve");
                if (this.sharedService.paramsObc) {
                  // let link = `${REDIRECT_SWIFT_URL}?retrieve=${response.data.hsToken}&obc=${this.sharedService.paramsObc}&GEMID1=C2B_&GEMID2=C2B_`;
                  let link = `${REDIRECT_SWIFT_URL}?retrieve=${response.data.hsToken}&obc=${this.sharedService.paramsObc}&GEMID1=C2B_${this.sharedService.paramsObc}_&GEMID2=C2B_${this.sharedService.paramsObc}_`;
                  console.log("Swift App Link when shortCode & obc is present retrieve", link);
                  window.location.href = link;
                }
                else if (this.sharedService.paramsshortCode) {
                  let link = `${REDIRECT_SWIFT_URL}?retrieve=${response.data.hsToken}&GEMID1=C2B_&GEMID2=C2B_`;
                  console.log("Swift App Link when shortCode is present retrieve", link);
                  window.location.href = link;
                }
                else {
                  let link = `${REDIRECT_SWIFT_URL}?retrieve=${response.data.hsToken}`;
                  console.log("Swift App Link retrieve", link);
                  window.location.href = link;
                }
            }
            if (response.data.leadRefNo) {
              this.sharedService.paramsappNumber = response.data.leadRefNo;
              this.sharedService.trackApplicationResponse = response;
              this.sharedService.applicantName = response.data.applicantDetails.firstName;
              this.sharedService.applicantApplicationNumber = response.data.applicationNumber;
              this.sharedService.navigateToCompleteApp = response.data.enableDataCaptureFlag ? response.data.enableDataCaptureFlag : null;
              this.sharedService.navigateToDocUpload = response.data.enableDocumentListFlag ? response.data.enableDocumentListFlag : null;
              this.sharedService.navigateToScheduleAppointment = response.data.enableAppointmentFlag ? response.data.enableAppointmentFlag : null;
              this.sharedService.navigateToAddon = response.data.enableAddOnListFlag ? response.data.enableAddOnListFlag : null;
              this.sharedService.navigateToCrossSell = response.data.enableCrossSellFlag ? response.data.enableCrossSellFlag : null;
              this.sharedService.navigateToResheduleAppointment = response.data.enableReSchdAppointmentFlag ? response.data.enableReSchdAppointmentFlag : null;
              // this.trackApplication();
              this.router.navigate(['/apply', 'track-app'], { queryParamsHandling: "preserve" });
            } else if (((this.sharedService.paramsmobileNo && this.sharedService.paramsfirstName) || this.sharedService.paramsshortCode) && response.data.applicantDetails.mobileNumber == this.mobileNumber) {
              this.sharedService.retrievedApplicationResponse = response;
              this.router.navigate(['/', 'apply'], { queryParamsHandling: "preserve", replaceUrl: true });
            }
            else {
              this.retrieverServiceError = ''
              this.sharedService.retrievedApplicationResponse = response;
              let chaneelCode = response.data.channelCode ? response.data.channelCode : '';
              this._cardtype = response.data && response.data.cardType ? response.data.cardType : '';
              if (chaneelCode) {
                if (chaneelCode == "EALB") {
                  this.sharedService.paramschannel = '901';
                  sessionStorage.setItem('channelId', '901');
                } else if (chaneelCode == "EABP") {
                  this.sharedService.paramschannel = '701';
                  sessionStorage.setItem('channelId', '701');
                }
              }

              if (this.sharedService.retrievedApplicationResponse.data.channelCode) {
                let masterReq = {
                  cardType: this.sharedService.retrievedApplicationResponse.data.cardType,
                  cardChannelCode: this.sharedService.retrievedApplicationResponse.data.channelCode,
                  cityList: 'N',
                  companyList: 'N',
                  bancaCityList: 'N',
                  userCity: this.sharedService.retrievedApplicationResponse.data.resiCity || null
                }
                this.loaderService.show()
                this.qdeService.fetchMatserData(masterReq).subscribe((res: any) => {
                  if (res.eapplyMasterDataRsType && res.eapplyMasterDataRsType.statusCode === "000") {
                    this.sharedService.InitialMasterResponse = res;
                    this.sharedService.sourceCode = 'DEFEAP';
                    // if ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') || (this.sharedService.paramschannel && this.sharedService.paramschannel == '901')) {
                    //   this.sharedService.promoCode = response 
                    //         && response.eapplyMasterDataRsType 
                    //         && response.eapplyMasterDataRsType.wcpParameters 
                    //         && response.eapplyMasterDataRsType.wcpParameters.promoCode 
                    //           ? response.eapplyMasterDataRsType.wcpParameters.promoCode: '' ;
                    // }
                    if (res.eapplyMasterDataRsType && res.eapplyMasterDataRsType.wcpParameters) {
                      this.sharedService.sourceCode = res.eapplyMasterDataRsType.wcpParameters.sourceCode;
                      this.sharedService.promoGroup = res.eapplyMasterDataRsType.wcpParameters.promoGroup;
                    }
                    if ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') || (this.sharedService.paramschannel && this.sharedService.paramschannel == '901')) {

                      if (this.sharedService.InitialMasterResponse && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode) {
                        this.sharedService.promoCode = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode;
                      } else {
                        if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
                          if (this._cardtype == 'USV2') {
                            this.sharedService.promoCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-unnati-card-promo-code').key_value;
                          } else {
                            this.sharedService.promoCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-promo-code').key_value;
                          }
                        }
                      }

                      if (this.sharedService.InitialMasterResponse && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoGroup) {
                        this.sharedService.promoGroup = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoGroup;
                      } else {
                        if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
                          if (this._cardtype == 'USV2') {
                            this.sharedService.promoGroup = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-unnati-card-promo-group').key_value;
                          } else {
                            this.sharedService.promoGroup = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-promo-group').key_value;
                          }
                        }
                      }

                      if (this.sharedService.InitialMasterResponse && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.sourceCode) {
                        this.sharedService.sourceCode = this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.sourceCode;
                      } else {
                        if (this.sharedService.paramschannel && this.sharedService.paramschannel == '901') {
                          this.sharedService.sourceCode = this.bancaPromoConfig.find(promo => promo.key_name == 'eapply-banca-default-source-code').key_value;
                        } else {
                          this.sharedService.sourceCode = 'DEFEAP';
                        }
                      }
                    }
                    this.loaderService.hide()
                  } else {
                    this.loaderService.hide()
                    window["digitalData"].error = { message: GENERIC_ERROR };
                    if (window['_satellite']) {
                      _satellite.track('form_error');
                    }
                    this.retrieverServiceError = GENERIC_ERROR;
                  }
                }, err => {
                  this.retrieverServiceError = GENERIC_ERROR;
                  window["digitalData"].error = { message: GENERIC_ERROR };
                  if (window['_satellite']) {
                    _satellite.track('form_error');
                  }
                  this.loaderService.hide()
                });
                // if ((this.sharedService.paramschannel && this.sharedService.paramschannel == '701') || (this.sharedService.paramschannel && this.sharedService.paramschannel == '901')) {
                //   this.sharedService.promoCode = this.sharedService.InitialMasterResponse 
                //         && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType 
                //         && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters 
                //         && this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode 
                //           ? this.sharedService.InitialMasterResponse.eapplyMasterDataRsType.wcpParameters.promoCode: ''
                // }
              }
              this.sharedService.applicantName = this.sharedService.retrievedApplicationResponse.data.firstName;
              this.mobileNumber = this.sharedService.retrievedApplicationResponse.data.mobileNumber;

              // let sequenceId = response.RetrieveLeadRsType.WSCallSequenceId ? response.RetrieveLeadRsType.WSCallSequenceId : '';
              // this.sharedService.amoSequeceNumber = sequenceId;
              if (IS_CAMPAIGN) {
                window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
              } else {
                window["digitalData"].page = { pageName: 'sbi-card:eapply:retrieve', pageType: 'Eapply' };
              }
              if (!this.fromShortCode) {
                this.sendOtpForValidation(this.mobileNumber, false);
                if (IS_CAMPAIGN) {
                  window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
                } else {
                  window["digitalData"].page = { pageName: 'sbi-card:eapply:c2b', pageType: 'Eapply' };
                }
              }
            }
          }
          else if (response.statusCode === "000" && response.data.dsignString === this.sharedService.uuidString) {
            console.log("redirecting to swift app");
            if (this.sharedService.paramsObc) {
              //let link = `${REDIRECT_SWIFT_URL}?retrieve=${response.data.hsToken}&obc=${this.sharedService.paramsObc}&GEMID1=C2B_&GEMID2=C2B_`;
              let link = `${REDIRECT_SWIFT_URL}?retrieve=${response.data.hsToken}&obc=${this.sharedService.paramsObc}&GEMID1=C2B_${this.sharedService.paramsObc}_&GEMID2=C2B_${this.sharedService.paramsObc}_`;
              console.log("Swift App Link when shortCode & obc is present retrieve", link);
              window.location.href = link;
            }
            else if (this.sharedService.paramsshortCode) {
              let link = `${REDIRECT_SWIFT_URL}?retrieve=${response.data.hsToken}&GEMID1=C2B_&GEMID2=C2B_`;
              console.log("Swift App Link when shortCode is present", link);
              window.location.href = link;
            }
            else {
              let link = `${REDIRECT_SWIFT_URL}?retrieve=${response.data.hsToken}`;
              console.log("Swift App Link", link);
              window.location.href = link;
            }
          }
          else if (response.statusCode === "003" && response.data.dsignString === this.sharedService.uuidString) {
            console.log("redirecting to swift app");
            if (this.sharedService.paramsObc) {
              //let link = `${REDIRECT_SWIFT_URL}?track=${response.data.hsToken}&obc=${this.sharedService.paramsObc}&GEMID1=C2B_&GEMID2=C2B_`;
              let link = `${REDIRECT_SWIFT_URL}?track=${response.data.hsToken}&obc=${this.sharedService.paramsObc}&GEMID1=C2B_${this.sharedService.paramsObc}_&GEMID2=C2B_${this.sharedService.paramsObc}_`;
              console.log("Swift App Link when shortCode & obc is present track", link);
              window.location.href = link;
            }
            else if (this.sharedService.paramsshortCode) {
              let link = `${REDIRECT_SWIFT_URL}?track=${response.data.hsToken}&GEMID1=C2B_&GEMID2=C2B_`;
              console.log("Swift App Link when shortCode is present", link);
              window.location.href = link;
            }
            else {
              let link = `${REDIRECT_SWIFT_URL}?track=${response.data.hsToken}`;
              console.log("Swift App Link", link);
              window.location.href = link;
            }
          }
          else {
            console.log("this is else block from validateRetrieveOtp application-tracking")
            this.optValidateCount += 1;
            this.otpValidationServiceError = verbiageList.invalidOtp;
            this.otp = null;
            // this.retrieverServiceError = GENERIC_ERROR;
            window["digitalData"].error = { message: GENERIC_ERROR };
          }
        }
        else if (response && response.status && response.status.toLowerCase() == 'failure') {
          this.retrieverServiceError = response.message
          this.sharedService.abortMessage = TRACK_APP.trackError;
          window["digitalData"].error = { message: this.retrieverServiceError };
          if (window['_satellite']) {
            _satellite.track('form_error');
          }
        }
        else {
          console.log("this is else block from validateRetrieveOtp application-tracking")
          this.optValidateCount += 1;
          this.otpValidationServiceError = verbiageList.invalidOtp;
          this.otp = null;
          // this.retrieverServiceError = GENERIC_ERROR;
          window["digitalData"].error = { message: GENERIC_ERROR };
        }
      }, error => {
        this.sharedService.abortMessage = TRACK_APP.trackError;
        window["digitalData"].error = { message: GENERIC_ERROR };
        if (window['_satellite']) {
          _satellite.track('form_error');
        }
        this.router.navigate(['/track-application', 'track-error']);
        this.retrieverServiceError = GENERIC_ERROR;
      })
    }
  }

// Digital track app shortcode validate OTP new method started here
  digitalTrackValidShortcodeOTP(){
    if (this.otp.length === 6) {
      let request = {
        mobileNumber:this.sharedService.shortCodeMobileNumber,
        reasonCode: this.sharedService.shortCodeReasonCode,
        otp: this.otp || null
      }
      this.sharedService.DigitalTrackAppAuthShortcode(request).subscribe((response: any) => {
        if (response) {
          response = TRACK_GEN_NEW_SHORTCODE_URL_DECRYPT ? this.encryptDecService.get(response) : response;
        }
        if (response && response.OtpValidationRsType.statusDescription === "Success" && response.OtpValidationRsType.statusCode === "000") {
          this.router.navigate(['/apply', 'track-app'], { queryParamsHandling: "preserve" });  
        }
        else if (response && response.OtpValidationRsType.status === 'Failure' && response.OtpValidationRsType.statusCode === "999") {
          this.retrieverServiceError = response.message
          window["digitalData"].error = { message: this.retrieverServiceError };
          if (window['_satellite']) {
            _satellite.track('form_error');
          }
        }
        else {
          this.optValidateCount += 1;
          this.otpValidationServiceError = verbiageList.invalidOtp;
          this.otp = null;
          window["digitalData"].error = { message: GENERIC_ERROR };
        }
      }, error => {
        this.router.navigate(['/track-application', 'track-error']);
      })
    }
  }
// Digital track app shortcode validate OTP new method end here

  numberOnlyPhone(event) {
    let regex2 = /[0-9]/;
    if (event.key.match(regex2)) {
      return true;
    } else {
      return false;
    }
  }

}
